import React, { memo } from "react";

/** Zelena kvačica u krugu — završeno ili odabrano u scenama čarobnjaka. */
const CheckIcon: React.FC = () => {
  return (
    <span className="flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100 text-emerald-600 flex-shrink-0">
      <svg
        className="w-3 h-3"
        viewBox="0 0 12 12"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M2.5 6.5l2.5 2.5 4.5-5" />
      </svg>
    </span>
  );
};

export default memo(CheckIcon);
